export default __webpack_public_path__ + "static/bg-couple-5b015458cf15f3144c1982b54846b2fc.jpg";